import React, { useState, useEffect } from "react";
import { DateTime } from "luxon";
import { createTheme, ThemeProvider } from "@material-ui/core";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import DateFnsUtils from "@date-io/luxon"; // choose your lib
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
// Recibe un periodo de tiempo (ayer, semana, esstemes, mespasado, esteano, anopasado,mes, ano)
// y la función a ejecutar en el componente padre cuando cambia el periodo
// y permite cambiar la selección y comunicarse con el padre a través de la función recibida
const theme = createTheme({
  palette: {
    // type: 'light',
    primary: {
      main: "#e3007e",
    },
    secondary: {
      main: "#f50057",
    },
  },
});
function SelectorFecha(props) {
  console.log(props);
  const [value, setValue] = useState('');
  const [fechainicio, setFechainicio] = useState("");
  const [fechafin, setFechafin] = useState("");
  useEffect(() => {
    setValue(props.periodo);
      switch (props.periodo) {
        // case "ayer":
        //   setFechainicio(
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
        //   );
        //   setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
        //   props.cambioperiodo(
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"),
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
        //   )
        //   break;

        case "semana":
          setFechainicio(
            DateTime.local().minus({ days: 7 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
          break;
        case "estemes":
          setFechainicio(
            DateTime.local().startOf("month").toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().endOf("month").toFormat("yyyyMMdd"));
          break;
        case "mespasado":
          setFechainicio(
            DateTime.local()
              .minus({ months: 1 })
              .startOf("month")
              .toFormat("yyyyMMdd")
          );
          setFechafin(
            DateTime.local()
              .minus({ months: 1 })
              .endOf("month")
              .toFormat("yyyyMMdd")
          );
          break;
        case "esteano":
          setFechainicio(DateTime.local().startOf("year").toFormat("yyyyMMdd"));
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
          break;
        case "anopasado":
          setFechainicio(
            DateTime.local()
              .minus({ year: 1 })
              .startOf("year")
              .toFormat("yyyyMMdd")
          );
          setFechafin(
            DateTime.local()
              .minus({ year: 1 })
              .endOf("year")
              .toFormat("yyyyMMdd")
          );
          break;
        case "mes":
          setFechainicio(
            DateTime.local().minus({ days: 31 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
          break;

        case "ano":
          setFechainicio(
            DateTime.local().minus({ days: 366 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
          break;
        default:
          setFechainicio(
            DateTime.local().startOf("month").toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
      }
  }, []);

  const handleChange = (event) => {
    console.log('handleChange | '+event.target.value);
    setValue(event.target.value);
        // if (event.target.value == "ayer") {
        //   setFechainicio(
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
        //   );
        //   setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
        //   props.cambioperiodo(
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"),
        //     DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
        //   );
        // }
        if (event.target.value == "semana") {
          setFechainicio(
            DateTime.local().minus({ days: 7 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
          props.cambioperiodo(
            DateTime.local().minus({ days: 7 }).toFormat("yyyyMMdd"),
            DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
          );
        }
        if (event.target.value == "estemes") {
          props.cambioperiodo(
            DateTime.local().startOf("month").toFormat("yyyyMMdd")
          ,
          // DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd")
          DateTime.local().endOf("month").toFormat("yyyyMMdd")
          )
        }
        if (event.target.value == "mespasado") {
          props.cambioperiodo
          (
            DateTime.local()
              .minus({ months: 1 })
              .startOf("month")
              .toFormat("yyyyMMdd")
          ,
          
            DateTime.local()
              .minus({ months: 1 })
              .endOf("month")
              .toFormat("yyyyMMdd")
          );
        }
        if (event.target.value == "esteano") {
          props.cambioperiodo(
            DateTime.local().startOf("year").toFormat("yyyyMMdd"),
          DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
        }
        if (event.target.value == "anopasado") {
          setFechainicio(
            DateTime.local()
              .minus({ year: 1 })
              .startOf("year")
              .toFormat("yyyyMMdd")
          );
          setFechafin(
            DateTime.local()
              .minus({ year: 1 })
              .endOf("year")
              .toFormat("yyyyMMdd")
          );
        }
        if (event.target.value == "mes") {
          setFechainicio(
            DateTime.local().minus({ days: 31 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
        }
        if (event.target.value == "ano") {
          setFechainicio(
            DateTime.local().minus({ days: 366 }).toFormat("yyyyMMdd")
          );
          setFechafin(DateTime.local().minus({ days: 1 }).toFormat("yyyyMMdd"));
        }
  };
  return (
    <AppBar
      // style={{ background: '#e3007e' }}
      sx={{
        backgroundColor: "#e3007e",
      }}
      position="static"
    >
      <Toolbar>
        <FormControl>
          <>
            Período: &nbsp; Del{" "}
            {DateTime.fromFormat(fechainicio, "yyyyMMdd")
              .setLocale("es")
              .toFormat("dd/MMMM/yyyy")}
            &nbsp; al{" "}
            {DateTime.fromFormat(fechafin, "yyyyMMdd")
              .setLocale("es")
              .toFormat("dd/MMMM/yyyy")}
          </>

          <RadioGroup
            value={value}
            onChange={handleChange}
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            {/* <FormControlLabel value="ayer" control={<Radio />} label="Ayer" /> */}
            <FormControlLabel
              value="semana"
              control={<Radio />}
              label="Última semana"
            />
            <FormControlLabel
              value="estemes"
              control={<Radio />}
              label="Este mes"
            />
            <FormControlLabel
              value="mespasado"
              control={<Radio />}
              label="Mes pasado"
            />
            <FormControlLabel
              value="esteano"
              control={<Radio />}
              label="Este Año"
            />
            <FormControlLabel
              value="anopasado"
              control={<Radio />}
              label="Ano pasado"
            />
            <FormControlLabel
              value="mes"
              control={<Radio />}
              label="ültimos 30 días"
            />
            <FormControlLabel
              value="ano"
              control={<Radio />}
              label="ültimo Año"
            />
          </RadioGroup>
        </FormControl>
      </Toolbar>
    </AppBar>
  );
}
export default SelectorFecha;
